/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpmetanote3Inputs */

const en_crosspostinghelpmetanote3 = /** @type {(inputs: Crosspostinghelpmetanote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: Meta's consent dialog (the facebook.com window) is required by Facebook and cannot be skipped or embedded into Pulsify - this is the same for every tool.`)
};

const de_crosspostinghelpmetanote3 = /** @type {(inputs: Crosspostinghelpmetanote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis: Der Zustimmungs-Dialog von Meta (das facebook.com-Fenster) ist von Facebook vorgeschrieben und lässt sich nicht überspringen oder in Pulsify einbetten – das ist bei allen Anbietern so.`)
};

/**
* | output |
* | --- |
* | "Note: Meta's consent dialog (the facebook.com window) is required by Facebook and cannot be skipped or embedded into Pulsify - this is the same for every tool." |
*
* @param {Crosspostinghelpmetanote3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpmetanote3 = /** @type {((inputs?: Crosspostinghelpmetanote3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpmetanote3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpmetanote3(inputs)
	return de_crosspostinghelpmetanote3(inputs)
});
export { crosspostinghelpmetanote3 as "crosspostingHelpMetaNote" }